export default {
    title: 'البحث',
    filter: 'المرشحات',
    hideFilter: 'اخفاء المرشحات',
    currentlyOnline: 'المتواجدون الآن',
    noSearchResults: 'لا يوجد احد',
    clear: 'مسح المرشحات'
}
